import { ClassificationCodeDto } from 'src/app/shared/interfaces';

export class ClassificationCode {
  id: number;
  description: string | null;
  code: string | null;
  actif: boolean;
  folderNameAndCode: string;

  constructor(data?: ClassificationCodeDto) {
    Object.assign(this, data);
  }
}
